<div class="bg-white py-7 px-8 max-w-screen-sm">
  <div class="flex justify-between">
    <h2 class="font-accent font-bold text-2xl leading-none">
      {{ shopName }}
    </h2>
    <button
      class="icon icon-cross text-sm"
      (click)="closeCart.emit()"
    ></button>
  </div>
  <app-overview-cart-item-atom
    *ngFor="let product of products"
    [price]="product[ProductKeys.Price] ?? 'INVALID'"
    [name]="product[ProductKeys.Name] ?? 'INVALID'"
    [description]="product[ProductKeys.Description] ?? 'INVALID'"
    [quantity]="product[ProductKeys.Quantity]"
  ></app-overview-cart-item-atom>
  <app-overview-cart-additional-atom
    *ngFor="let additional of additionalItems"
    [text]="additional.label"
    [price]="additional.value"
    [icon]="additional.icon"
  ></app-overview-cart-additional-atom>
  <div class="flex justify-between text-1xsl py-3">
    <p class="font-bold">Total</p>
    <p>
      <app-price-atom
        [amount]="totalAmount"
        [format]="true"
      ></app-price-atom>
    </p>
  </div>
  <div class="flex flex-col py-3">
    <textarea
      id="comment"
      rows="1"
      placeholder="Commentaire sur votre commande"
      class="text-neutral-500 leading-5 px-6 py-2.5 bg-neutral-50 border border-neutral-300 rounded"
      [(ngModel)]="comment"
    ></textarea>
  </div>
  <div class="py-3">
    <div>
      <app-button-atom
        label="Commander"
        size="L"
        type="primary"
        (clickEventEmitter)="submitCart.emit(this.comment)"
      ></app-button-atom>
    </div>
    <div class="mt-2">
      <app-button-atom
        label="Ajouter des articles"
        size="L"
        type="light"
        (clickEventEmitter)="closeCart.emit()"
      ></app-button-atom>
    </div>
  </div>
</div>
